<script module lang="ts">
	import { parse } from "svelte/compiler";

	export function dateStuff() {

		const ISO_REGEX = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[01])$/;
		const US_REGEX = /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[01])\/\d{4}$/;
		
		// returns midnight of the supplied date
		function toLocalMidnight(d: Date) {
			return new Date(d.getFullYear(), d.getMonth(), d.getDate());
		}

		// formats date as ISO date string
		function getISODateOnly(date: Date) {
			//if (date instanceof Date) {
				const year = date.getFullYear();
				const month = (date.getMonth() + 1).toString().padStart(2, "0");
				const day = date.getDate().toString().padStart(2, "0");
				return `${year}-${month}-${day}`;
			//} else {
			//	console.log("getISODateOnly", date);
			//	const newDate = new Date();
			//	const year = newDate.getFullYear();
			//	const month = (newDate.getMonth() + 1).toString().padStart(2, "0");
			//	const day = newDate.getDate().toString().padStart(2, "0");
			//	return `${year}-${month}-${day}`;
			//}
		}

		function getUsDateOnly(date: Date | string): string{
			var rtn = "";
			if (date instanceof Date) {
				const d = new Date(date);
				const year = d.getFullYear();
				const month = (d.getMonth() + 1).toString().padStart(2, "0");
				const day = d.getDate().toString().padStart(2, "0");
				rtn = `${month}/${day}/${year}`;
				} else if (typeof date == "string"){
					const d = parseDateOnly(date);
					if (d === null) return date;
					const year = d.getFullYear();
					const month = (d.getMonth() + 1).toString().padStart(2, "0");
					const day = d.getDate().toString().padStart(2, "0");
					rtn = `${month}/${day}/${year}`;
				}
			return rtn;
		}

		// takes a date or string(yyyy-mm-dd or mm/dd/yyyy) and adds n number of days. then returns same data type as passed in
		function addDays(d: Date | string, n: number): Date | string | null {
			if (d instanceof Date) {
				const x = new Date(d);
				x.setDate(x.getDate() + n);
				return x;
			} else if (typeof d === "string") {
				const x = parseDateOnly(d);
				if (x === null) return d;
				x.setDate(x.getDate() + n);
				return getISODateOnly(x);
			}
		}

		// takes a date or string(yyyy-mm-dd or mm/dd/yyyy) and adds n number of months. then returns same data type as passed in
		function addMonths(d: Date | string, n: number): Date | string | null {
			if (d instanceof Date) {
				const x = new Date(d);
				x.setMonth(x.getMonth() + n);
				return x;
			} else if (typeof d === "string") {
				const x = parseDateOnly(d);
				if (x === null) return d;
				x.setMonth(x.getMonth() + n);
				return getISODateOnly(x);
			}
		}

		// takes a date or string(yyyy-mm-dd or mm/dd/yyyy) and adds n number of years. then returns same data type as passed in
		function addYears(d: Date | string, n: number): Date | string | null {
			if (d instanceof Date) {
				const x = new Date(d);
				x.setFullYear(x.getFullYear() + n);
				return x;
			} else if (typeof d === 'string'){
				const x = parseDateOnly(d);
				if (x === null) return d;
				x.setFullYear(x.getFullYear() + n);
				return getISODateOnly(x);
			}
		}

		//parses US or ISO formatted date and returns as a date (or null if string is not valid date)
		function parseDateOnly(s: string): Date | null {
			// ISO
			if (ISO_REGEX.test(s)) {
				const [y, m, d] = s.split("-").map(Number);
				return new Date(y, m - 1, d);
			}
			// US
			if (US_REGEX.test(s)) {
				const [m, d, y] = s.split("/").map(Number);
				return new Date(y, m - 1, d);
			}
			return null;
		}
		
		function isValidISODate(dateStr: string): boolean {
			const m = ISO_REGEX.exec(dateStr);
			if (!m) return false;

			const [_, yStr, moStr, dStr] = m;
			const y = Number(yStr), mo = Number(moStr), d = Number(dStr);

			if (mo < 1 || mo > 12 || d < 1 || d > 31) return false;
			const dt = new Date(Date.UTC(y, mo - 1, d));
			return (
				!isNaN(dt.getTime()) &&
				dt.getUTCFullYear() === y &&
				dt.getUTCMonth() === mo - 1 &&
				dt.getUTCDate() === d
			);
		}

		function isValidUSDate(dateStr: string): boolean {
			const m = US_REGEX.exec(dateStr);
			if (!m) return false;

		  const [_, moStr, dStr, yStr] = m;
			const mo = Number(moStr);
			const d = Number(dStr);
			const y = Number(yStr);
			
			if (mo < 1 || mo > 12 || d < 1 || d > 31) return false;
			
			const dt = new Date(Date.UTC(y, mo - 1, d));
			return (
				!isNaN(dt.getTime()) &&
				dt.getUTCFullYear() === y &&
				dt.getUTCMonth() === mo - 1 &&
				dt.getUTCDate() === d
			);
		}

		let valState = $state();

		function normalizeDate(val: unknown): Date | null {
			if (val == null || val == "") return null;
			if (val instanceof Date) return toLocalMidnight(val);
			if (typeof val === "string") {
				const parsed = parseDateOnly(val);
				return parsed ? toLocalMidnight(parsed) : null;
			}
			return null;
		}
		
		return {
			toLocalMidnight,
			getISODateOnly,
			getUsDateOnly,
			addDays,
			addMonths,
			addYears,
			parseDateOnly,
			isValidISODate,
			normalizeDate,
		};
	}
</script>
